import { useState, useEffect, useRef, useCallback } from "react";

const messages = {
  initial: ["Okay", "Sure", "Alright"],
  intermediate: [
    "Still getting a response",
    "Just a bit longer",
    "One more moment please",
    "Almost done",
    "Working on it",
    "Still on it",
    "Just a moment please",
    "Please give me a moment",
    "Just another second",
  ],
  final: [
    "Appreciate your patience",
    "Getting you a response",
    "Thanks for hanging in there",
    "Almost there now",
    "One more moment",
    "Your patience means a lot",
    "Thank you for waiting",
    "Appreciate you holding on",
    "Thanks for your patience",
    "I really appreciate the wait",
  ],
};

const useWaitMessage = () => {
  const [message, setMessage] = useState("");
  const timeoutsRef = useRef<NodeJS.Timeout[]>([]);

  useEffect(() => {
    return () => {
      clearMessageWait();
    };
  }, []);

  const startMessageWait = useCallback(() => {
    clearMessageWait();

    const showMessage = () => {
      setMessage(
        messages.initial[Math.floor(Math.random() * messages.initial.length)]
      );
      timeoutsRef.current.push(
        setTimeout(() => {
          setMessage(
            messages.intermediate[
              Math.floor(Math.random() * messages.intermediate.length)
            ]
          );
        }, 5000)
      ); // 8 sec

      timeoutsRef.current.push(
        setTimeout(() => {
          setMessage(
            messages.final[Math.floor(Math.random() * messages.final.length)]
          );
        }, 12000)
      ); // 15 sec

      timeoutsRef.current.push(
        setTimeout(() => {
          setMessage(
            "There was an error. Perhaps a connection. Please try again."
          );
        }, 19000)
      ); // 22 sec
    };

    timeoutsRef.current.push(setTimeout(showMessage, 3000)); // 3 sec
  }, []);

  const clearMessageWait = (isSaveMessage = true) => {
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];
    if (!isSaveMessage) return;
    setMessage("");
  };

  return { startMessageWait, clearMessageWait, message };
};

export default useWaitMessage;
